export const PREMIUM = 'Premium Care Physician';
export const QUALITY_MET = 'Quality Care Physician';
export const QUALITY_NOT_MET = 'Does Not Meet Premium Quality Criteria';
export const NOT_EVALUATED = 'Not Evaluated for Premium Care';
export const NOT_DESIGNATED = 'Not Designated';
export const MEET_CRITERIA = 'Meets Criteria';
export const NOT_MEET_CRITERIA = 'Does Not Meet Criteria';
export const PREMIUM_CARE = 'Premium Care';

export const HEART_MAP = {
  [PREMIUM]: {
    index: 0,
    imagePath: '/Images/icon-premium-dark.svg',
    altText: 'Premium Care Physician Icon',
    label: PREMIUM
  },
  [PREMIUM_CARE]: {
    index: 1,
    imagePath: '/Images/icon-premium-dark.svg',
    altText: 'Premium Care Physician Icon',
    label: PREMIUM
  },
  [QUALITY_MET]: {
    index: 2,
    imagePath: '/Images/icon-quality.svg',
    altText: 'Quality Care Physician Icon',
    label: QUALITY_MET
  },
  [QUALITY_NOT_MET]: {
    index: 3,
    imagePath: '',
    altText: '',
    label: QUALITY_NOT_MET
  },
  [NOT_DESIGNATED]: {
    index: 4,
    imagePath: '',
    altText: '',
    label: NOT_DESIGNATED
  },
  [NOT_EVALUATED]: {
    index: 5,
    imagePath: '/Images/icon-quality-not-evaluated.svg',
    altText: 'Not Evaluated for Premium Care Icon',
    label: NOT_EVALUATED
  }
};

export const SORT_AND_COLORS = {
  [PREMIUM]: {
    index: 0,
    order: 0,
    color: '#003C71'
  },
  [PREMIUM_CARE]: {
    index: 1,
    order: 1,
    color: '#003C71'
  },
  [QUALITY_MET]: {
    index:2,
    order:2,
    color: '#21B01E'
  },
  [NOT_EVALUATED]: {
    index:3,
    order: 3,
    color: '#6636ba'
  },
  [QUALITY_NOT_MET]: {
    index:4,
    order: 4,
    color: '#8C9599'
  },
  [NOT_DESIGNATED]: {
    index:5,
    order: 5,
    color: '#CBCCCD'
  }
};
export const LOGGED_OUT_KEY = 'loggedOut';